import React from 'react';
import axios from 'axios';
import {
  Heading,
  Avatar,
  Box,
  Center,
  Image,
  Flex,
  Text,
  Stack,
  Link,
  Badge,
  Button,
  useColorModeValue,
  Divider,
  SimpleGrid,
  HStack,
} from '@chakra-ui/react';
import { EditIcon } from '@chakra-ui/icons';

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  StackDivider,
} from '@chakra-ui/react';
import {
  chakra,
  Container,
  VStack,
  VisuallyHidden,
  List,
  ListItem,
} from '@chakra-ui/react';

export default function Paccomplishments() {
    const [data, setData] = React.useState([]);
  React.useEffect(() => {
    axios.get('https://glb-api.onrender.com/student/accomplishment',{params:{token:localStorage.getItem("token")}})
    .then(res => {
      console.log(res.data);

      setData(res.data);
    })
    .catch(err => {
      console.log(err);
      // setError('Failed to fetch the details right now.')
    })
  }, [])
  return (
    <>
      <div>
        <Box>
          <Card variant={'elevated'} minH={'100vh'}>
            <CardBody>
              <Box bg="white" shadow="md" borderRadius="md" p="6" width="100%">
                <Flex alignItems="center" justifyContent="space-between">
                  <Heading as="h1" size="2xl">
                    Accomplishments
                  </Heading>
                  <Button
                    leftIcon={<EditIcon />}
                    marginTop={'4px'}
                    colorScheme="blue"
                    variant="outline"
                    size={'lg'}
                    display={{ base: 'none', md: 'inline-flex' }}
                    fontSize={'2xl'}
                    href={'#'}
                  >
                    Edit info
                  </Button>
                </Flex>
              </Box>
              <Box className="mt-10">
                <VStack spacing={10}>
                  <Center width={'100%'}>
                    <Box width={'100%'}>
                      <Card variant={'elevated'}>
                        <CardHeader>
                          <Box bg="white" p={5} borderRadius="md">
                            <Heading as="h2" textAlign="left" size="2xl" mb={3}>
                            {data.title}
                            </Heading>

                            <Flex marginTop={'20px'}>

                              <Box ml="3">
                                <Text fontWeight="bold" fontSize={'x-large'}>
                                  {data.organisation}

                                </Text>
                                <Text fontSize="lg">
                                  January-2023| {data.location}
                                </Text>
                                <Divider marginTop={'10px'} />
                                <Text fontSize="lg" marginTop={"10px"}>
                                {data.description}
                  </Text>

                              </Box>
                            </Flex>
                          </Box>


                        </CardHeader>

                        <CardBody></CardBody>
                      </Card>
                    </Box>
                  </Center>
                </VStack>
              </Box>
              <Box className="mt-10">
                <VStack spacing={10}>
                  <Center width={'100%'}>
                    <Box width={'100%'}>
                      <Card variant={'elevated'}>
                        <CardHeader>
                          <Box bg="white" p={5} borderRadius="md">
                            <Heading as="h2" textAlign="left" size="2xl" mb={3}>
                            Innovation Awards
                            </Heading>

                            <Flex marginTop={'20px'}>

                              <Box ml="3">
                                <Text fontWeight="bold" fontSize={'x-large'}>
                                  OrgX

                                </Text>
                                <Text fontSize="lg">
                                  January-2023| Indore
                                </Text>
                                <Divider marginTop={'10px'} />
                                <Text fontSize="lg" marginTop={"10px"}>
                                I am thrilled to have been honored with the Innovation Awards for UI development in OrgX. This recognition is a testament to my dedication to enhancing user experiences through innovative design and development solutions.

Throughout my time at OrgX, I have focused on creating intuitive and visually appealing interfaces that make it easy for users to engage with our products. I have collaborated closely with cross-functional teams to understand user needs and create solutions that meet those needs in the most effective way possible.

My approach to UI development is grounded in a deep understanding of user psychology and behavior. By incorporating insights from user research and testing, I have been able to create interfaces that are not only beautiful but also highly functional and user-friendly.

I am proud to have been recognized for my contributions to the field of UI development, and I look forward to continuing to push the boundaries of what's possible in this exciting and ever-evolving field
                  </Text>

                              </Box>
                            </Flex>
                          </Box>


                        </CardHeader>

                        <CardBody></CardBody>
                      </Card>
                    </Box>
                  </Center>
                </VStack>
              </Box>

            </CardBody>
          </Card>

        </Box>
      </div>
    </>
  );
}


